import { get } from 'lodash';

function getFieldValue(field = {}) {
  return get(field, 'value', '');
}

export default getFieldValue;
